import { api } from './api';

export interface CampoOuvidoria {
  campo: string;
  id_tipo_campo: string;
  obrigatorio: boolean;
  ordem: number;
}

export interface CampoTipo {
  id: string;
  nome: string;
  tipo_input: string;
}

export interface FormularioCampo {
  id: string;
  campo: string;
  obrigatorio: boolean;
  ordem: number;
  tipoCampo: CampoTipo;
}

export interface FormularioOuvidoria {
  id: string;
  id_grupo: string;
  titulo: string;
  descricao?: string;
  ativo: boolean;
  criado_em: string;
  militarCriou?: { id: string; nick: string };
  campos: FormularioCampo[];
}

export interface OuvidoriaCampo {
  id: string;
  valor: string;
  campoDef: FormularioCampo;
}

export interface Ouvidoria {
  id: string;
  nick_autor?: string;
  anonimo: boolean;
  criado_em: string;
  campos: OuvidoriaCampo[];
}

export interface CriarFormularioDTO {
  titulo: string;
  descricao?: string;
  campos: CampoOuvidoria[];
}

const ouvidoriaService = {
  async criarFormulario(id_grupo: string, data: CriarFormularioDTO): Promise<FormularioOuvidoria> {
    const response = await api.post(`/grupos/${id_grupo}/ouvidoria/formularios`, data);
    return response.data;
  },

  async listarFormularios(id_grupo: string): Promise<FormularioOuvidoria[]> {
    const response = await api.get(`/grupos/${id_grupo}/ouvidoria/formularios`);
    return response.data;
  },

  async alterarStatus(id_formulario: string, ativo: boolean): Promise<FormularioOuvidoria> {
    const response = await api.patch(`/grupos/ouvidoria/formularios/${id_formulario}/status`, { ativo });
    return response.data;
  },

  async listarOuvidorias(id_formulario: string): Promise<Ouvidoria[]> {
    const response = await api.get(`/grupos/ouvidoria/formularios/${id_formulario}/ouvidorias`);
    return response.data;
  },
};

export { ouvidoriaService };
